<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <label>{{ tra.do_you_have_discount_coupon }}</label>
            </div>
            <div class="col-md-6">
                <div class="form-check form-check-inline mr-0 ml-4">
                    <input 
                        :value="haveCoupon"
                        @change="$emit('update-have-coupon', $event.target.value)"
                        name="have_coupon" 
                        type="radio"
                        style="height: 20px; width: 20px;" 
                        value="1"
                        :class="'form-check-input mr-0 ml-3 bg-secondary'" 
                    /> 
                    <label class="form-check-label">{{ tra.yes }}</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check form-check-inline mr-0 ml-4">
                    <input 
                        @change="handleNoCoupon"
                        :value="haveCoupon"
                        name="have_coupon"
                        type="radio" 
                        style="height: 20px; width: 20px;" 
                        value="0"
                        :class="'form-check-input mr-0 ml-3 bg-secondary'" 
                    /> 
                    <label class="form-check-label">{{ tra.no }}</label>
                </div>
            </div>
        </div>
        
        <div v-if="haveCoupon == '1'">
            <hr class="my-2">
            <div class="row">
                <div class="col-9">
                    <div class="form-group">
                        <input 
                            :value="couponCode"
                            @input="$emit('update-coupon-code', $event.target.value)"
                            name="coupon_code" 
                            type="text"
                            :class="'form-control bg-transparent'"
                            :placeholder="tra.enter_discount_code"
                        >
                    </div>
                </div>
                <div class="col-3">
                    <button 
                        v-if="!couponStatus" 
                        @click="$emit('apply-coupon')" 
                        type="button"
                        class="btn rounded-10 text-white bg-secondary-color"
                    >
                        {{ tra.apply }}
                    </button>

                    <button 
                        v-if="couponStatus" 
                        @click="$emit('remove-coupon')" 
                        type="button"
                        class="btn rounded-10 text-white bg-danger"
                    >
                        {{ tra.delete }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CouponSection',
    props: {
        haveCoupon: [String, Number],
        couponCode: String,
        couponStatus: String,
        tra: Object,
    },
    emits: ['update-have-coupon', 'update-coupon-code', 'apply-coupon', 'remove-coupon'],
    methods: {
        handleNoCoupon(event) {
            this.$emit('update-have-coupon', event.target.value);
            this.$emit('remove-coupon');
        }
    }
};
</script>